import(/* webpackMode: "eager" */ "/src/src/app/panduan/page.tsx");
